import { useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { API_ENDPOINTS } from '../config/api'
import { useLanguage } from '../contexts/LanguageContext'

function getVisitorId() {
  const key = 'avelia_visitor_id'
  const existing = localStorage.getItem(key)
  if (existing) return existing
  const value = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`
  localStorage.setItem(key, value)
  return value
}

function getSessionId() {
  const key = 'avelia_visit_session_id'
  const existing = sessionStorage.getItem(key)
  if (existing) return existing
  const value = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`
  sessionStorage.setItem(key, value)
  return value
}

function getPageTitle(pathname) {
  if (pathname === '/') return document.title || 'Avelia'
  return document.title || pathname
}

function sendVisitPayload(payload) {
  const body = JSON.stringify(payload)
  const blob = new Blob([body], { type: 'application/json' })
  if (navigator.sendBeacon?.(API_ENDPOINTS.RECORD_WEBSITE_VISIT, blob)) {
    return
  }
  fetch(API_ENDPOINTS.RECORD_WEBSITE_VISIT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
    keepalive: true,
  }).catch(() => {})
}

export function useWebsiteVisitTracking() {
  const location = useLocation()
  const { language } = useLanguage()

  const payload = useMemo(() => ({
    visitor_id: getVisitorId(),
    session_id: getSessionId(),
    page_path: location.pathname,
    page_url: window.location.href,
    page_title: getPageTitle(location.pathname),
    source_page: document.referrer || '',
    referer: document.referrer || '',
    language,
    ip_address: '',
    user_agent: navigator.userAgent,
  }), [location.pathname, language])

  useEffect(() => {
    sendVisitPayload(payload)
  }, [payload])
}
